<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-start>
      <v-flex xs12 text-left pb-6 px-3>
        <span style="color: #000; font-size: 20px; font-family: poppinsbold"
          >Order List</span
        >
      </v-flex>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 sm6 md3 px-4>
            <v-autocomplete
              v-model="uid"
              :items="customers"
              clearable
              item-text="name"
              item-value="_id"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="customers"
            >
              <!-- <option :id="null" :value="null">All</option> -->
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-autocomplete
              outlined
              dense
              color="#8d8d8d"
              placeholder="Shop Name"
              v-model="sellerId"
              :items="sellerList"
              item-text="sellerid.shopName"
              item-value="sellerid._id"
              item-color="#FF1313"
              hide-details
              clearable
              class="text-left"
              label="Shop Name"
            >
            </v-autocomplete>
          </v-flex>
          <!-- <v-flex xs12 sm6 md3 px-4>
            <v-select
              v-model="paymentStatus"
              :items="paymentStatusList"
              item-text="name"
              item-value="value"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="Payment Status"
            >
            </v-select>
          </v-flex> -->
          <v-flex xs12 sm6 md3 px-4>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  label="From Date"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fromDate"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3 px-4>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  label="To Date"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="toDate"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <!-- <v-flex xs12 sm6 md3 px-4>
            <v-select
              v-model="orderStatus"
              :items="orderStatusList"
              item-text="name"
              item-value="value"
              item-color="#8d8d8d"
              color="#8d8d8d"
              outlined
              dense
              label="Status"
            >
            </v-select>
          </v-flex> -->
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <v-layout wrap>
          <v-flex v-if="orders.length > 0" xs12 pt-0 text-left>
            <!-- <span style="color: #000; font-size: 18px; font-family: poppinsbold"
              >Requests</span
            > -->
            <OrderList
              :orderData="orders"
              :orderStatus="orderStatus"
              :pages="pages"
              :pageFilters="pageFilters2"
              @stepper="winStepper"
            />
          </v-flex>

          <v-flex v-else xs12 text-left pa-4>
            <!-- <span style="color: #000; font-size: 18px; font-family: poppinsbold"
              >Requests</span
            > -->
            <br />
            <span class="textField2"> Order list is empty !! </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import OrderList from "./orderData";
export default {
  components: {
    OrderList,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      orders: [],
      reservationData: [],
      programme: null,
      slotDetail: null,
      programeData: [],
      details: [],
      slotDetails: [],
      guest: [],
      programs: [],
      slotItems: [],
      panel: [],
      disabled: false,
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
      currentPage: 1,
      pages: 0,
      date: new Date(),
      tabValue: 0,
      customers: [],
      uid: null,
      orderStatus: null,
      paymentStatus: null,
      orderStatusList: [
        { name: "All", value: null },
        // { name: "Incomplete", value: "Incomplete" },
        { name: "Pending", value: "Pending" },
        { name: "Ordered", value: "Ordered" },
        { name: "Dispatched", value: "Dispatched" },
        { name: "Cancelled", value: "Cancelled" },
      ],
      paymentStatusList: [
        { name: "All", value: null },
        // { name: "Incomplete", value: "Incomplete" },
        { name: "Initiate", value: "Initiate" },
        { name: "Success", value: "Success" },
        { name: "Failure", value: "Failure" },
      ],
      type: null,
      userList: [],
      sellerList: [],
      sellerId: null,
      prevRoute: localStorage.getItem("LS_ROUTE_KEY"),
    };
  },

  beforeMount() {
    if (this.fromDate || this.pageFilters1.fromDate) {
      this.fromDate.setDate(this.fromDate.getDate());
      this.fromDate = this.fromDate.toISOString().substr(0, 10);
    }
    if (this.toDate || this.pageFilters1.toDate) {
      this.toDate.setDate(this.toDate.getDate());
      this.toDate = this.toDate.toISOString().substr(0, 10);
    }
    if (this.$route.query.type == "total") this.fromDate = this.toDate = null;
    // this.getData();
    this.getUsers();
    console.log(this.pageFilters1, "hgv", this.prevRoute);

    if (this.prevRoute == "/OrderInfo") {
      this.uid = this.pageFilters1.uid;
      // this.fromDate=this.pageFilters1.fromDate
      // this.toDate=this.pageFilters1.toDate
      this.sellerId = this.pageFilters1.shop;
      this.currentPage = this.pageFilters1.currentPage;
      console.log(this.pageFilters1.currentPage, "hygvc");
    }
    this.getSellers();
  },
  mounted() {
    if (localStorage.LS_ROUTE_KEY == "/OrderInfo") {
      console.log("boss its working", localStorage.OrderfromDate);
      if (localStorage.OrderfromDate == "null") {
        this.fromDate = "";
      } else {
        this.fromDate = localStorage.OrderfromDate;
      }
      if (localStorage.OrdertoDate == "null") {
        this.toDate = "";
      } else {
        this.toDate = localStorage.OrdertoDate;
      }
    }
  },

  computed: {
    pageFilters1() {
      if (this.$store.state.orderPageFilters) {
        return this.$store.state.orderPageFilters;
      } else {
        return {};
      }
    },
    pageFilters2() {
      return {
        type: this.$route.name,
        currentPage: this.currentPage,
        shop: this.sellerId,
        fromDate: this.fromDate,
        toDate: this.toDate,
        uid: this.uid,
      };
    },
  },
  watch: {
    uid() {
      this.getData();
    },
    sellerId() {
      this.getData();
    },
    // paymentStatus() {
    //   this.getData();
    // },
    // orderStatus() {
    //   this.getData();
    // },
    fromDate() {
      // if (this.fromDate == null)
      this.getData();
    },
    toDate() {
      if (this.fromDate != null) this.getData();
    },
  },
  methods: {
    winStepper(windowData) {
      if (windowData) {
        if (
          !this.pageFilters1.currentPage ||
          this.pageFilters1.currentPage > 0 ||
          this.pageFilters1.currentPage != undefined
        ) {
          this.currentPage = windowData.currentPage;
          console.log(windowData.currentPage, "hyghhvc");
        }

        if (windowData.pages) this.pages = windowData.pages;
        // this.type = windowData.type;
        this.getData();
      }
    },
    getData() {
      if (this.fromDate != null) {
        localStorage.setItem("OrderfromDate", this.fromDate);
      } else {
        localStorage.setItem("OrderfromDate", this.fromDate);
      }
      if (this.toDate != null) {
        localStorage.setItem("OrdertoDate", this.toDate);
      } else {
        localStorage.setItem("OrdertoDate", this.toDate);
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          uid: this.uid,
          from: this.fromDate,
          to: this.toDate,
          limit: 25,
          page: this.currentPage,
          sellerId: this.sellerId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.orders = response.data.data;
            this.pages = response.data.totalPages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSellers() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.sellerList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsers() {
      axios({
        method: "POST",
        url: "/users/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          role: "Customer",
          status: "Active",
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.customers = response.data.data;
            this.customers.forEach(function (itm) {
              if (itm.customerid)
                itm.name =
                  itm.customerid.firstName + " " + itm.customerid.lastName;
              else itm.name = "No Name";
            });
            // this.customers.unshift({ name: "All", _id: null });
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      // var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
<style>
.head {
  font-family: poppinsregular;
  font-size: 14px;
}
.content {
  font-family: poppinsbold;
  font-size: 13px;
}
</style>